import { atom, selectorFamily, atomFamily } from 'recoil';
import * as vodaLend from '../api/vodaLend';
import dayjs from 'dayjs';

const fetchStateCapitalFacility = async (businessId, applicationId) => vodaLend.getCapitalFacility(businessId, applicationId);

export const capitalFacilityState = atomFamily({
  key: 'capitalFacilityState',
  default: null
});

export const creditFacilityDetailsQuery = selectorFamily({
  key: 'creditFacilityDetailsQuery',
  get: ({ businessId, applicationId }) => async () => await fetchStateCapitalFacility(businessId, applicationId)
});

export const withdrawalAmountState = atom({
  key: 'withdrawalAmountState',
  default: 0
});

export const amountToWithdraw = selectorFamily({
  key: 'amountToWithdraw',
  get:
    ({ businessId, applicationId }) =>
      ({ get }) => {
        const capitalFacility = get(capitalFacilityState({ businessId, applicationId }));
        const amountAvailable = capitalFacility?.amountAvailable;
        return amountAvailable || 0;
      },
  set:
    () =>
      ({ set }, newValue) => {
        set(withdrawalAmountState, newValue);
      }
});

const MIN_WITHDRAWAL_AMT = 1000;

export const getWithdrawalQuoteQuery = selectorFamily({
  key: 'getWithdrawalQuoteQuery',
  get:
    ({ amount, businessId, applicationId }) =>
      async () => {
        if (!amount || typeof amount !== 'number' || amount < MIN_WITHDRAWAL_AMT) {
          return null;
        }

        const data = await vodaLend.getWithdrawalQuote(amount, businessId, applicationId);

        if (!data) {
          return 'withdrawalInProgress';
        }

        const sched = (data?.repaymentSchedule || []).map((s) => ({
          displayDate: dayjs(s.date).format('DD MMM YYYY'),
          capital: s.principalAmount,
          cost: s.costAmount,
          repayment: s.totalAmount
        }));

        data.repaymentSchedule = sched;

        return data;
      }
});

export const rcfTransactionsQuery = selectorFamily({
  key: 'rcfTransactionsQuery',
  get:
    ({ businessId }) =>
      async () => {

        const data = await vodaLend.getTransactions(businessId);

        if (!data) {
          return 'transactionListInProgress';
        }

        const rcfTransactionsHistory = (data || []).map((s) => ({
          'date': dayjs(s.date).format('DD MMM YYYY'),
          'description': s.status,
          'reference': s.id,
          'capital': s.capital,
          'withdrawalAmount': s.amount
        }));

        return rcfTransactionsHistory;
      }
});
